export default __webpack_public_path__ + "static/media/game-line-5.07c3e704.png";